import { Component } from "@angular/core";
import { PurchaseHistoryService } from "./purchaseHistory.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormControl } from "@angular/forms";
import { Constants } from "../constants/constants";
import { FormStatus } from "../enums/enums";
import { ActivatedRoute, Router } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
@Component({
	selector: "purchaseHistory",
	templateUrl: "/app/purchaseHistory/purchaseHistory.template.html",
	providers: [PurchaseHistoryService]
})
export class PurchaseHistoryComponent {

	purchaseHistory = [] as Array<IPurchaseHistoryModel>;
	completedPurchaseHistory = [] as Array<IPurchaseHistoryModel>;
	filter = new FormControl();
	search = "";
	lastSortedColumnApproval = "id";
	lastSortedColumnHistory = "id";
	isDescApproval = true;
	isDescHistory = true;
	purchaseHistoryRowCount = 0;
	purchaseHistoryPageSize = 20;
	purchaseHistoryPageNumber = 1;
	completedPurchaseHistoryRowCount = 0;
	completedPurchaseHistoryPageSize = 20;
	completedPurchaseHistoryPageNumber = 1;
	restUrl = Constants.attachtmentsUrl;
	isSave = false;
	title = "";
	firstHeader = "";
	hasManagerApprovals = false;
	loadingPurchaseHistory: boolean = true;
	loadingCompletedPurchases: boolean = true;
	attachmentname: string = "";
	constructor(private purchaseHistoryService: PurchaseHistoryService, private toast: ToastsManager, private constants: Constants, private activatedRoute: ActivatedRoute, private router: Router) { }

	ngOnInit() {
		this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

		this.isSave = this.router.url.indexOf("savedPurchases") > -1;
		this.getHasManagerApprovals();

		this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
			if(!this.isSave) {
				this.title = "Purchase History";
				this.firstHeader = "Open Requisitions";

				if(term) {
					this.searchHistory(term, 1);
					this.searchCompletedHistory(term, 1);
				} else {
					this.getPurchaseHistory();
					this.getCompletedPurchaseHistory();
				}
			} else {
				this.title = "Saved Purchases";
				this.firstHeader = "Saved Purchases";

				if(term)
					this.searchSavedPurchases(term, 1);
				else
					this.getSavedPurchases();
			}
		});
	}

	getSavedPurchases(): void {
		this.loadingPurchaseHistory = true;
		this.purchaseHistory = [];
		if(this.search && this.search.length > 0)
			this.searchSavedPurchases(this.search, this.purchaseHistoryPageNumber);
		else {
			this.purchaseHistoryService.getSavedPurchases(this.constants.user.username, this.purchaseHistoryPageNumber, this.purchaseHistoryPageSize).subscribe((purchaseHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(purchaseHistory) {
					this.purchaseHistory = purchaseHistory.purchases;
					this.purchaseHistoryRowCount = purchaseHistory.rowCount;
				}
				this.loadingPurchaseHistory = false;
			});
		}
	}

	getPurchaseHistory(): void {
		this.loadingPurchaseHistory = true;
		this.purchaseHistory = [];
		if(this.search && this.search.length > 0)
			this.searchHistory(this.search, this.purchaseHistoryPageNumber);
		else {
			this.purchaseHistoryService.getPurchaseHistory(this.constants.user.username, this.purchaseHistoryPageNumber, this.purchaseHistoryPageSize).subscribe((purchaseHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
                if (purchaseHistory) {
                    console.log(purchaseHistory);
                    this.purchaseHistory = purchaseHistory.purchases;
                    this.purchaseHistoryRowCount = purchaseHistory.rowCount;
                }
                else
                    console.log('fail');

				this.loadingPurchaseHistory = false
			});
		}
	}

	getCompletedPurchaseHistory(): void {
		this.loadingCompletedPurchases = true;
		this.completedPurchaseHistory = [];
		if(this.search && this.search.length > 0)
			this.searchCompletedHistory(this.search, this.completedPurchaseHistoryPageNumber);
		else {
			this.purchaseHistoryService.getCompletedPurchaseHistory(this.constants.user.username, this.completedPurchaseHistoryPageNumber, this.completedPurchaseHistoryPageSize).subscribe((completedHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(history) {
					this.completedPurchaseHistory = completedHistory.purchases;
					this.completedPurchaseHistoryRowCount = completedHistory.rowCount;
				}
				this.loadingCompletedPurchases = false;
			});
		}
	}

	showHideDetails(purchaseHistory: IPurchaseHistoryModel): void {
		if(purchaseHistory.isVisible === undefined)
			purchaseHistory.isVisible = false;

		purchaseHistory.isVisible = !purchaseHistory.isVisible;
	}

	updateApprovalStatus(purchase: IPurchaseHistoryModel): void {
		this.loadingPurchaseHistory = true;
		this.purchaseHistoryService.updateApprovalStatus(purchase.id, FormStatus.Cancelled, this.constants.user.username).subscribe((result: boolean): void => {
			if(result) {
				this.getPurchaseHistory();
				this.getCompletedPurchaseHistory();

				this.toast.success(`Purchase ${purchase.id} has been updated.`, "Success", { toastLife: 5000 });
			} else
				this.toast.error("Error processing you request.", "Error", { toastLife: 10000 });
			this.loadingPurchaseHistory = false;
		});
	}

	searchHistory(term: string, pageNumber: number): void {
		if(term) {
			this.purchaseHistoryService.getPurchaseHistorySearch(this.constants.user.username, pageNumber, this.purchaseHistoryPageSize, term).subscribe((purchaseHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(purchaseHistory) {
					this.purchaseHistoryPageNumber = pageNumber;
					this.purchaseHistory = purchaseHistory.purchases;
					this.purchaseHistoryRowCount = purchaseHistory.rowCount;
					this.loadingPurchaseHistory = false;
				}
			});
		}
	}

	searchSavedPurchases(term: string, pageNumber: number): void {
		if(term) {
			this.purchaseHistoryService.getPurchaseHistorySearch(this.constants.user.username, pageNumber, this.purchaseHistoryPageSize, term).subscribe((purchaseHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(purchaseHistory) {
					this.purchaseHistoryPageNumber = pageNumber;
					this.purchaseHistory = purchaseHistory.purchases;
					this.purchaseHistoryRowCount = purchaseHistory.rowCount;
					this.loadingPurchaseHistory = false;
				}
			});
		}
	}

	searchCompletedHistory(term: string, pageNumber: number): void {
		if(term) {
			this.purchaseHistoryService.getCompletedPurchaseHistorySearch(this.constants.user.username, pageNumber, this.completedPurchaseHistoryPageSize, term).subscribe((completedHistory: { purchases: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(completedHistory) {
					this.completedPurchaseHistoryPageNumber = pageNumber;
					this.completedPurchaseHistory = completedHistory.purchases;
					this.completedPurchaseHistoryRowCount = completedHistory.rowCount;
					this.loadingCompletedPurchases = false;
				}
			});
		}
	}

	showApprovalArrows(column: string): boolean {
		return this.isDescApproval && this.lastSortedColumnApproval === column;
	}

	setSortOrderApproval(columnName: string) {
		if(this.lastSortedColumnApproval === columnName)
			this.isDescApproval = !this.isDescApproval;
		else
			this.isDescApproval = true;

		this.lastSortedColumnApproval = columnName;
	}

	showHistoryArrows(column: string): boolean {
		return this.isDescHistory && this.lastSortedColumnHistory === column;
	}

	setSortOrderHistory(columnName: string) {
		if(this.lastSortedColumnHistory === columnName)
			this.isDescHistory = !this.isDescHistory;
		else
			this.isDescHistory = true;

		this.lastSortedColumnHistory = columnName;
	}

	canEdit(history: IPurchaseHistoryModel): boolean {
		return history.status === "Waiting Manager Approval" || history.status === "Saved";
	}

	getHasManagerApprovals() {
		this.purchaseHistoryService.getHasManagerApprovals(this.constants.user.email).subscribe((hasApprovals: boolean): void => {
			if (hasApprovals)
				this.hasManagerApprovals = hasApprovals;
		});
	}
	downloadAttachment(formTypeId: number, formId: number, fileName: string) {
		this.purchaseHistoryService.downloadAttachment(formTypeId, formId, fileName).subscribe((blob) => {
			const fileURL = (window.URL || window.webkitURL).createObjectURL(blob);

			// Open in new browser tab
			const tab = window.open(fileURL, '_blank');

			if (!tab) {
				alert('Please allow popups for this site to preview files.');
			}

			// Cleanup memory later
			setTimeout(() => {
				try {
					(window.URL || window.webkitURL).revokeObjectURL(fileURL);
				} catch (e) { }
			}, 10000);
		}, err => {
			console.error(err);
			alert('Error opening file');
		}
		);
	}
}